import styled from "styled-components";

export const Slider = styled.div<{
    scrollable: boolean;
}>`
    display: flex;
    gap: 50px;
    overflow-x: ${({ scrollable }) => (scrollable ? "auto" : "hidden")};
    overscroll-behavior-inline: contain;
    scroll-snap-type: inline mandatory;
    scroll-padding-inline: var(--_spacer, 1rem);
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;
